import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useAppServices } from "../../../../../../../hook/services";

const initialForm = {
  label: "",
  key: "",
  description: "",
};

const AddFieldModal = ({ app, handleRefresh, initialData, updateIndex }) => {
  const AppService = useAppServices();

  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData(initialForm);
    }
  }, [initialData]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormData(initialForm);
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.label || !formData.key) {
      toast.error("Label and Key are required");
      return;
    }

    try {
      setLoading(true);
      let formFields = [...app?.formFields];
      if (initialData) {
        console.log(updateIndex);
        console.log(formData);
        formFields[updateIndex] = formData;
      } else {
        formFields.push(formData);
      }
      const payload = {
        _id: app._id,
        formFields: formFields,
      };
      console.log(payload);
      const { response } = await AppService.apps.update({ payload });
      if (response) {
        if (initialData) {
          toast.success("Field updated successfully");
        } else {
          toast.success("Field added successfully");
        }

        handleRefresh();
        handleClose();
      }
    } catch (err) {
      toast.error(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {initialData ? (
        <button className="btn btn-outline-primary btn-sm" onClick={handleOpen}>
          <i className="bi bi-pencil"></i>
        </button>
      ) : (
        <button
          className="btn btn-primary px-4 py-2 rounded-3 shadow-sm"
          onClick={handleOpen}
        >
          <i className="bi bi-plus-circle me-2"></i>Add Field
        </button>
      )}

      {/* Modal */}
      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content border-0 shadow">
              <div className="modal-header bg-light">
                <h5 className="modal-title fw-bold">
                  {initialData ? "Add Form Field" : "Edit Form Field"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>

              <div className="modal-body p-4">
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Label</label>
                    <input
                      type="text"
                      className="form-control"
                      name="label"
                      value={formData.label}
                      onChange={handleChange}
                      placeholder="Enter field label"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Key</label>
                    <input
                      type="text"
                      className="form-control"
                      name="key"
                      value={formData.key}
                      onChange={handleChange}
                      placeholder="Enter unique key"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Short Description</label>
                    <textarea
                      className="form-control"
                      name="short_description"
                      rows={3}
                      value={formData.short_description}
                      onChange={handleChange}
                      placeholder="Enter Short Description"
                    />
                  </div>

                  <div className="d-flex justify-content-end mt-4">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-success"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : !initialData ? "Save" : "Update"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddFieldModal;
